import { createConsts, createActions } from '../../utils/redux';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

export const consts = createConsts(
  'ui',
  'overlay',
  'SHOW',
  'HIDE',
  'TOGGLE_VISIBILITY',
);
export const actions = createActions(consts);
export default (
  state = {
    visible: false,
  },
  action,
) => {
  switch (action.type) {
    case consts.SHOW:
      return {
        ...state,
        visible: true,
      };
    case consts.HIDE:
    case LOCATION_CHANGE:
      return {
        ...state,
        visible: false,
      };
    case consts.TOGGLE_VISIBILITY:
      return {
        ...state,
        visible: !state.visible,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/ui/overlay.js